import React, { FC } from 'react'
import { Text, HStack, IconProps, Flex } from '@chakra-ui/react'
import {
  DeFlag,
  EnFlag,
  EsFlag,
  FrFlag,
  JaFlag,
  useColor,
  ZhFlag,
} from '@rw1/shared-lib'
import { getLanguageOptions } from '@rw1/localization'
import { useLocalization, SupportedLocale } from '../../localization'

const localeFlags: Record<SupportedLocale, FC<IconProps>> = {
  de: DeFlag,
  en: EnFlag,
  es: EsFlag,
  fr: FrFlag,
  ja: JaFlag,
  zh: ZhFlag,
}

type TLocaleOption = {
  id: SupportedLocale
  label: string
}

export const LocalePicker: FC = () => {
  const { localize, setLocale } = useLocalization()
  const textColor = useColor({ nuance: 0, palette: 'text' })

  const languageOptions: TLocaleOption[] = getLanguageOptions(
    'webpages',
  ).map(({ locale, label }) => ({ label, id: locale }))

  return (
    <Flex
      alignItems="center"
      direction={{
        base: 'column',
        md: 'row',
      }}
      gridGap={{
        base: 2,
        md: 6,
      }}>
      <Text color={textColor} fontWeight="semibold" textTransform="uppercase">
        {localize('common.language')}
      </Text>
      <HStack
        spacing={{
          base: 8,
          md: 4,
        }}>
        {languageOptions.map((locale) => {
          const localeId = locale.id
          const Flag = localeFlags[localeId]

          return (
            <Flag
              _hover={{
                cursor: 'pointer',
                opacity: 0.6,
              }}
              height={4}
              key={localeId}
              onClick={() => setLocale(localeId)}
              transition="opacity 200ms linear"
              width="auto"
            />
          )
        })}
      </HStack>
    </Flex>
  )
}
